import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Styled from '../../../lab/Styled';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
import './slider.css';
import { DefaultHandle, DefaultHandleWithTooltip } from './handles';
/**
 * @extends {React.Component<import('../types').FormInputSliderProps> }
 */

var SliderField =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SliderField, _React$Component);

  function SliderField() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SliderField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SliderField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onChange = function (val) {
      _this.props.onChange(val);
    };

    return _this;
  }

  _createClass(SliderField, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          value = _this$props.value,
          min = _this$props.min,
          max = _this$props.max,
          step = _this$props.step,
          handle = _this$props.handle,
          measure = _this$props.measure,
          tooltip = _this$props.tooltip;
      var sliderProps = {
        min: min,
        max: max,
        step: step
      };
      sliderProps.handle = handle;

      if (!sliderProps.handle) {
        if (tooltip) {
          if (typeof tooltip === 'function') sliderProps.handle = function (props) {
            return React.createElement(DefaultHandleWithTooltip, Object.assign({}, props, {
              format: tooltip
            }));
          };else sliderProps.handle = function (props) {
            return React.createElement(DefaultHandleWithTooltip, props);
          };
        } else {
          sliderProps.handle = DefaultHandle;
        }
      }

      if (measure) sliderProps.ref = measure;
      return React.createElement(Styled, {
        styles: styles,
        name: "ECSliderField"
      }, function (classes) {
        return React.createElement("div", {
          className: classes.root,
          "data-testid": "slider"
        }, React.createElement(Slider, Object.assign({}, sliderProps, {
          value: value,
          onChange: _this2.onChange
        })));
      });
    }
  }]);

  return SliderField;
}(React.Component);

var styles = function styles() {
  return {
    root: {}
  };
};

SliderField.defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  'data-testid': 'slider'
};
export default SliderField;